import { render } from "./TheInvalidFeedback.vue?vue&type=template&id=8bdb57f2"
import script from "./TheInvalidFeedback.vue?vue&type=script&lang=js"
export * from "./TheInvalidFeedback.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Softwaresul\\Projetos Node\\LWP\\Nil Key\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__